/**
 * Extract a date (YYYY-MM-DD) from free-text status/description strings.
 * Returns the first valid date found, or null if none.
 */

const MONTH_MAP: Record<string, number> = {
  jan: 0, january: 0,
  feb: 1, february: 1,
  mar: 2, march: 2,
  apr: 3, april: 3,
  may: 4,
  jun: 5, june: 5,
  jul: 6, july: 6,
  aug: 7, august: 7,
  sep: 8, september: 8,
  oct: 9, october: 9,
  nov: 10, november: 10,
  dec: 11, december: 11,
};

// "Apr 29, 2026" or "April 29, 2026" — with or without comma
const MONTH_DAY_YEAR = /\b(jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:tember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\s+(\d{1,2}),?\s+(\d{4})\b/i;

// ISO format: "2026-04-29"
const ISO_DATE = /\b(\d{4})-(\d{2})-(\d{2})\b/;

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

export function extractDateFromText(...texts: (string | null | undefined)[]): string | null {
  for (const text of texts) {
    if (!text) continue;

    // Try "Month Day, Year" format first (most common in status text)
    const mdyMatch = text.match(MONTH_DAY_YEAR);
    if (mdyMatch) {
      const monthNum = MONTH_MAP[mdyMatch[1].toLowerCase()];
      const day = parseInt(mdyMatch[2], 10);
      const year = parseInt(mdyMatch[3], 10);
      if (monthNum !== undefined && day >= 1 && day <= 31 && year >= 2000) {
        return `${year}-${pad(monthNum + 1)}-${pad(day)}`;
      }
    }

    // Try ISO date
    const isoMatch = text.match(ISO_DATE);
    if (isoMatch) {
      const year = parseInt(isoMatch[1], 10);
      const month = parseInt(isoMatch[2], 10);
      const day = parseInt(isoMatch[3], 10);
      if (year >= 2000 && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
        return `${year}-${pad(month)}-${pad(day)}`;
      }
    }
  }

  return null;
}
